import React, {useState} from 'react';
// @ts-ignore
import * as styles from "../style.module.css";
import SectionHeader from "../sectionHeader";
import SectionContent from "./sectionContent";
import SectionSubmit from "../sectionSubmit";
import {saveSection} from "../helpers";
import {useCheckoutContext} from "../../../../contexts/CheckoutContext";

export const CODE = 'additional_info';
export const TITLE = 'Additional Information';

export default function AdditionalInfo({step, cartData} ) {
    // @ts-ignore
    const [checkout, setCheckout] = useCheckoutContext();
    const isActive = checkout.activeStep===step;

    const [cache, setCache] = useState({
        additional_uploads: [],
        additional_confirmation_emails: '',
        is_confirmation_emails_valid: true,
    });

    const section = checkout[CODE] ?? {
        additional_uploads: cache.additional_uploads,
        additional_confirmation_emails: cache.additional_confirmation_emails,
    };

    const disable = !cache.is_confirmation_emails_valid;

    async function submit() {
        saveSection(
            CODE,
            checkout,
            setCheckout,
            section,
            {
                canChange: true,
                additional_uploads: cache.additional_uploads,
                additional_confirmation_emails: cache.additional_confirmation_emails,

            }
        )
    }

    return (
        <div className={styles.section}>
            <SectionHeader step={step} code={CODE} title={TITLE} />
            {isActive && <SectionContent cache={cache} setCache={setCache}/>}
            {isActive && <SectionSubmit callback={submit} error={null} disable={disable} />}
        </div>
    );

}
